import React, { useEffect, useRef, useState } from 'react';
import { useTranslate, useLogin, useNotify, useLogout, useDataProvider } from 'react-admin';
import { Container, Typography, Box, Stack } from '@mui/material';
import { getRegisterFormData } from './Common';
import { Helmet } from 'react-helmet';
import AuthHelper from '../utils/AuthHelper';
import { useNavigate } from 'react-router-dom';
import RegisterLayout from './RegisterLayout';
import RegisterSubmitButton from './RegisterSubmitButton';

interface RegisterFormData {
  partnerEmail?: string;
  userPassword?: string;
}


const Completion: React.FC = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const login = useLogin();
  const logout = useLogout();
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [inviteSite, setInviteSite] = useState<string | null>(null);

  useEffect(() => {
    // Footerと同じロジックでsessionStorageからinviteSiteを取得
    const site = sessionStorage.getItem('inviteSite');
    setInviteSite(site);
    
    const formData = getRegisterFormData() as RegisterFormData;
    if (formData) {
      const { partnerEmail, userPassword } = formData;
      if (partnerEmail && userPassword) {
        timeoutRef.current = setTimeout(async () => {
          handleLogin();
        }, 10000); // 10秒後に自動ログイン
      }
    }

    // クリーンアップ関数でタイムアウトをクリア
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [login, logout, notify, dataProvider]);

  const handleLoginRedirect = async () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    handleLogin();
  };

  const handleLogin = async () => {
    const formData = getRegisterFormData() as RegisterFormData;
    if (formData) {
      const { partnerEmail, userPassword } = formData;
      if (partnerEmail && userPassword) {
        const inviteLoginId = sessionStorage.getItem('inviteLoginId');
        if (inviteLoginId) {
          try {
            // パートナー情報を取得してsessionStorageに格納
            const partnerInfo = await dataProvider.getPartnerLoginInfo(inviteLoginId);
            sessionStorage.setItem('currentTenantId', inviteLoginId);
            sessionStorage.setItem('cognitoUserPoolId', partnerInfo.userPoolId);
            sessionStorage.setItem('cognitoClientId', partnerInfo.cognitoClientId);
          } catch (error) {
            console.error('Failed to fetch partner info:', error);
          }
        }

        try {
          // ログイン情報を取得
          await login({ username: partnerEmail, password: userPassword });
          navigate(`/`, { replace: true });
        } catch (error) {
          notify(AuthHelper.getErrorKeyCode(error), { type: 'error' });
        }
      }
    }
  };

  return (
    <RegisterLayout>
      <Container>
        <Helmet>
          <title>{translate('resources.registers.name.Completion')}</title>
        </Helmet>
        <Stack spacing={5}>
          <Typography variant="h4">{translate('resources.registers.name.Completion')}</Typography>

          <Typography>
            ご登録ありがとうございます。{inviteSite ? `${inviteSite}をご利用可能になりました。` : 'successfeeをご利用可能になりました。'}
            <br />
            <br />
            10秒後に自動で管理ページにログインします。
            <br />
            ページが切り替わらない場合は、以下ログインボタンを押してください。
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <RegisterSubmitButton onClick={handleLoginRedirect}>ログイン</RegisterSubmitButton>
          </Box>
        </Stack>
      </Container>
    </RegisterLayout>
  );
};

export default Completion;
